module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Company Name (if any)",
      "id": "company_name",
      "error": _vm.form.errors.get('company_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_name", $$v)
      },
      expression: "form.company_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Recipient Nick Name",
      "id": "nick_name",
      "error": _vm.form.errors.get('nick_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.nick_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "nick_name", $$v)
      },
      expression: "form.nick_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "id": "first_name",
      "error": _vm.form.errors.get('first_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "id": "last_name",
      "error": _vm.form.errors.get('last_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "tel",
      "label": "Phone",
      "id": "phone",
      "error": _vm.form.errors.get('phone')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Email",
      "id": "email",
      "error": _vm.form.errors.get('email')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Address Line 1",
      "id": "line1",
      "error": _vm.form.errors.get('line1')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.line1),
      callback: function($$v) {
        _vm.$set(_vm.form, "line1", $$v)
      },
      expression: "form.line1"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Address Line 2",
      "id": "line2",
      "error": _vm.form.errors.get('line2')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.line2),
      callback: function($$v) {
        _vm.$set(_vm.form, "line2", $$v)
      },
      expression: "form.line2"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Address Line 3",
      "id": "line3",
      "error": _vm.form.errors.get('line3')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.line3),
      callback: function($$v) {
        _vm.$set(_vm.form, "line3", $$v)
      },
      expression: "form.line3"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "City",
      "id": "city",
      "error": _vm.form.errors.get('city')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "states",
      "label": "State",
      "id": "state",
      "error": _vm.form.errors.get('state')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.$set(_vm.form, "state", $$v)
      },
      expression: "form.state"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Zip",
      "id": "zip",
      "error": _vm.form.errors.get('zip')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.zip),
      callback: function($$v) {
        _vm.$set(_vm.form, "zip", $$v)
      },
      expression: "form.zip"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Country",
      "id": "country",
      "error": _vm.form.errors.get('country')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "checkbox",
      "label": "Is Residential Address",
      "id": "residential",
      "error": _vm.form.errors.get('residential')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.residential),
      callback: function($$v) {
        _vm.$set(_vm.form, "residential", $$v)
      },
      expression: "form.residential"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.create ? 'Create Recipient' : 'Save Changes'))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1030f20a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/UserRecipientForm.vue
// module id = 501
// module chunks = 0